
/* injects from baggage-loader */
require('./show-full-conversation-modal.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('showFullConversationModal', {
    templateUrl: '/app/components/deal-sheet/modals/show-full-conversation-modal.component.html',
    controller: ShowFullConversationModal,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/* @ngInject */
function ShowFullConversationModal() {
    var $ctrl = this;

    $ctrl.$onInit = init;
    $ctrl.endCommunicationAction = endCommunicationAction;
    $ctrl.isAutoAssistantConversationOpen = false;

    function init() {
        $ctrl.isAutoAssistantConversationOpen = $ctrl.resolve.getIsAutoAssistantConversationOpenVariable();
        $ctrl.resolve.getAutoAssistantConversation().then(function (data) {
            $ctrl.body = data;
        });
    }

    function endCommunicationAction() {
        $ctrl.resolve.endAutoAssistCommunication();
        $ctrl.isAutoAssistantConversationOpen = false;
    }
}
